import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '../Themes';

export default StyleSheet.create({
  textStyle: {
    color: Colors.dark_grey,
    fontSize: 14,
    lineHeight: 18,
    fontFamily: Fonts.type.VodafoneRg,
  },
});
